'use client';

import { c as _c } from "react/compiler-runtime";
import { useTopNav } from '@src/components/TopNavV3/TopNavContext';
import { TopNavDesktopBar } from '@src/components/TopNavV3/TopNavDesktop/TopNavDesktopBar';
import { TopNavDesktopSlidingPanel } from '@src/components/TopNavV3/TopNavDesktop/TopNavDesktopSlidingPanel';
import { cn } from '@src/utils/tailwind';
export const TopNavDesktop = () => {
  const $ = _c(11);
  const {
    isExpanded,
    setExpanded
  } = useTopNav();
  let t0;
  if ($[0] !== setExpanded) {
    t0 = () => setExpanded(false);
    $[0] = setExpanded;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TopNavDesktopBar />;
    t2 = <TopNavDesktopSlidingPanel />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isExpanded) {
    t3 = cn("invisible fixed inset-0 z-30 transition-all", {
      "backdrop-blur-sm visible bg-bodi-black-text/80": isExpanded
    });
    $[4] = isExpanded;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div className={t3} />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t0 || $[9] !== t4) {
    t5 = <nav className="relative hidden lg:block" onMouseLeave={t0}>{t1}{t2}{t4}</nav>;
    $[8] = t0;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};